import { HttpErrorResponse } from "@angular/common/http";
import { inject, InjectionToken } from "@angular/core";
import { OrganizationView } from "app/models/organization/organization";
import { NavigationService } from "app/services/navigation.service";
import { OrganizationService } from "app/services/organization.service";
import { UserService } from "app/services/user.service";
import { filter, forkJoin, map, merge, repeat, retry, Subject, switchMap, tap } from "rxjs";
import { User } from 'app/models/user/user';
import { Router } from "@angular/router";

export const APPGUARD = new InjectionToken("APP_GUARD", {
  factory: () => {
    const navigationService = inject(NavigationService);
    const userService = inject(UserService);
    const organizationService = inject(OrganizationService);
    const router = inject(Router);
    const chO$ = new Subject<void>();
    const INITAPP = organizationService.getOrganizations().pipe(
      repeat({ delay: () => chO$ }),
      tap({
        next: (organizations) => {
          if (organizations?.length > 0) {
            organizationService.organizations = organizations;
            return;
          }
          router.navigate(['/company/complete-registration']);
        },
        error: (error) => {
          if (error instanceof HttpErrorResponse && (error.status === 500))
            router.navigate(['/errors/maintenance']);
        },
      }),
      switchMap(() => organizationService.organizationInit().pipe(
        tap(() => console.log('orgInit'))
      )),
      retry({ count: 1, delay: 1000 }),
      tap({
        error: (err) => {
          console.error(err);
          router.navigate(['/errors/something-went-wrong']);
        }
      }),
      map((organization: OrganizationView) => {
        const user = organization.users?.at(0);
        if (user) {
          return user;
        } else router.navigate(['access-denied'])
      }),
      switchMap(user => {
        const userId = user.id;
        return forkJoin({
          user: userService.viewUser(userId),
          orgUser: organizationService.viewUser(userId)
        }).pipe(
          map(({ user, orgUser }) => {
            const member = {
              ...orgUser,
              lastOrganizationWorkedIn: user?.lastOrganizationWorkedIn,
              displayName: !user.displayName ? `User-${user.id}` : user.displayName
            };
            return member;
          })
        )
      }),
      // filter((user) => {
      //   const lastOrganizationWorkedIn = user.lastOrganizationWorkedIn;
      //   const isCompareOrganization = lastOrganizationWorkedIn && (organizationService.organizationSelectedId === lastOrganizationWorkedIn);
      //   if (!isCompareOrganization) {
      //     organizationService.localStorageService.setItem('organizationSelected', lastOrganizationWorkedIn);
      //     chO$.next();
      //   }
      //   return isCompareOrganization;
      // }),
      switchMap((user: User) => {
        return navigationService.get(user.role).pipe(
          tap(() => {
            console.log(user);
            userService.setUser(user);
          })
        );
      }),
      map(() => true),
    );
    return merge(INITAPP, userService.isUserGuard$);
  }
});